module.exports = __webpack_public_path__ + "img/frame (200).82297446.jpg";